import { z } from 'zod'
import { m } from '@/lib/paraglide/messages'

export function createEInvoiceBuyerSchema() {
    return z.discriminatedUnion('buyer_type', [
        z.object({
            buyer_type: z.literal('consumer'),
            buyer_name: z.string().trim(),
        }),
        z.object({
            buyer_type: z.literal('company'),
            buyer_name: z
                .string()
                .trim()
                .min(1, m.einvoice_buyer_name_required()),
            tax_code: z.string().trim().min(1, m.einvoice_buyer_tax_required()),
            address: z
                .string()
                .trim()
                .min(1, m.einvoice_buyer_address_required()),
            email: z.union([
                z.literal(''),
                z.string().trim().email(m.einvoice_buyer_email_invalid()),
            ]),
        }),
    ])
}
export type EInvoiceBuyerValues = z.infer<
    ReturnType<typeof createEInvoiceBuyerSchema>
>
